export default "__VITE_ASSET__CS98Lx5Y__"